import React from 'react'
import { Button } from 'antd';
import { Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';

import HomePage from './pages/HomePage';
import BucketPage from './pages/BucketPage';
import './styles/App.css'

//路由和layout
export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const setTitle = (path) => {
    switch (path) {
      case "/bucket":
        return "Bucket列表"

      default:
        return "选择Bucket"
    }
  }

  return (
    <>
      <div id='base-layout'>
        <div className='title'>{setTitle(location.pathname)}</div>
        <Button style={{ float: 'right', marginTop: '-31px' }} onClick={() => navigate('/home')}>回到首页</Button>
        <div className='a-line'></div>

        <Routes>
          <Route path='/' element={<Navigate to='/home' />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/bucket" element={<BucketPage />} />
        </Routes>
      </div>
    </ >
  )
}

